/* Raghu 27/10/2022 3225736869 Table UI enhancements alignment fixes
Prakash 10/31/2022 3225736869 added Table Pagination.
saikrishna 11/03/2022 3225736869 changed the paginationOptions
*/
import React, {useState} from 'react';
// import MaterialTable, { MTableBody, MTableBodyRow } from "material-table";
import {Grid, TablePagination} from '@material-ui/core';
import {tableIcons} from '../../../../../components/TableIcons';
import {tablePageRows, defaultRows} from '../../../../../constants/ReusableTablePagination';
import DeleteTableRecordPopup from './../../../../../util/DeleteTableRecordPopup';
import GuiTable from '../../../../../components/FormComponents/GuiTable';
import EditOutlinedIcon from '@material-ui/icons/EditOutlined';
import DeleteOutlineOutlinedIcon from '@material-ui/icons/DeleteOutlineOutlined';

export default function JobDetailsTable({
  formData,
  setFormData,
  deletedRules,
  setDeletedRules,
  setIsEditMode,
  rowData,
  setRowData,
  jobDetails,
  setOldRuleCode,
}) {
  const columns = [
    // {
    //   title: "S.No",
    //   field: "seqNo",
    //   cellStyle: { maxWidth: 500 },
    //   minWidth: "300px",
    // },
    {
      title: 'Task Code',
      field: 'taskCode',
      cellStyle: {maxWidth: 500},
      minWidth: '350px',
    },
    {
      title: 'Task Type',
      field: 'tasktType',
      cellStyle: {maxWidth: 500},
      minWidth: '350px',
    },

    {
      title: 'Task Parameters',
      field: 'taskParameters',
      minWidth: '400px',
    },
  ];
  const [userData, setUserData] = useState(null);
  const [isDelete, setIsDelete] = useState(false);

  const handleEditRow = (rowData) => {
    setIsEditMode(true);
    setRowData(rowData);
  };
  const handleDelete = (rowData) => {
    setUserData(rowData);
    setIsDelete(true);
  };
  const handleCloseDialog = () => {
    setIsDelete(false);
  };
  const handleSubmit = () => {
    new Promise((resolve) => {
      setTimeout(() => {
        const data = [...formData];
        const newData = data.filter((row) => row.taskCode !== userData.taskCode);
        setFormData(newData);
        // const existdata = false;
        // userData?.taskId && deletedRules.length >0 ? deletedRules.forEach(element => {
        //   element === userData?.taskId ? !existdata : existdata
        // }) :
        userData?.taskId && deletedRules.length > 0 ?
          setDeletedRules([...deletedRules, userData.taskId]) :
          userData?.taskId && setDeletedRules([userData.taskId]);
        resolve();
        handleCloseDialog();
      }, 1000);
    });
  };

  return (
    <>
      <DeleteTableRecordPopup open={isDelete} dialogClose={handleCloseDialog} title="Delete NightJobs" 
        value={`Are you sure you want to delete this Job?`} handleSubmit={handleSubmit}/>
      <Grid item xs={12}>
        <div className={`custom-table global-field-table custom-actions-icon  drag-and-drop-table custom-map-sec`}>
          <GuiTable
            title=""
            columns={columns}
            icons={tableIcons}
            data={formData}
            textAlign="left"
            options={{
              search: false,
              toolbar: false,
              pageSize: defaultRows,
              pageSizeOptions: tablePageRows,
              emptyRowsWhenPaging: false,
              headerStyle: {
                fontWeight: 'bold',
                fontSize: '0.938rem',
                padding: '16px',
              },
            }}
            components={{

              Pagination: (props) => (
                <TablePagination
                  {...props}
                  SelectProps={{
                    inputProps: {'aria-label': 'Rows per screen'},
                  }}
                  labelRowsPerPage={'Rows per screen:'}
                  rowsPerPageOptions={tablePageRows}
                  onChangeRowsPerPage={(event) => {
                    props.onChangeRowsPerPage(event);
                  }}
                />

              ),
            }}

            actions={[
              {
                icon: () => (
                  <>
                    <EditOutlinedIcon/>
                  </>
                ),
                tooltip: 'Edit',
                onClick: (event, rowData) => {
                  handleEditRow(rowData);
                  setOldRuleCode(rowData.taskCode);
                  setRowData(rowData);
                },
              },
              {
                icon: () => (
                  <>
                    <DeleteOutlineOutlinedIcon/>
                  </>
                ),
                // disabled: !breCode && !disableDelete,
                tooltip: 'Delete',
                onClick: (event, rowData) => handleDelete(rowData),
              },
            ]}
          />
        </div>
      </Grid>
    </>
  );
}
